import CustomSelectButton from './CustomSelectButton';
import CustomSelectOption from './CustomSelectOption';
import CustomSelectOptionList from './CustomSelectOptionList';
import CustomSelectRoot from './CustomSelectRoot';
import type { CustomSelectComposition } from './types';

import './CustomSelect.scss';

const CustomSelect: CustomSelectComposition = {
    Root: CustomSelectRoot,
    Button: CustomSelectButton,
    OptionList: CustomSelectOptionList,
    Option: CustomSelectOption,
};

export default CustomSelect;
